export * from './components/effects-list';

export * from './api';

export * from './types';

export const CONFIG = {
  responsive: {
    entrance: {
      config: 'responsive',
      includeGroups: ['entrance', 'animation'],
      excludeGroups: ['legacy'],
    },
    entranceLegacy: {
      config: 'responsive',
      includeGroups: ['entrance', 'animation', 'legacy'],
    },
    ongoing: {
      config: 'responsive',
      includeGroups: ['ongoing', 'animation'],
    },
    scroll: {
      config: 'responsive',
      includeGroups: ['scroll', 'animation'],
      excludeGroups: ['continuous'],
    },
    scrollIn: {
      config: 'responsive',
      rangeGroup: 'in',
      includeGroups: ['scroll', 'in', 'animation'],
    },
    scrollOut: {
      config: 'responsive',
      rangeGroup: 'out',
      includeGroups: ['scroll', 'out', 'animation'],
    },
    scrollContinuous: {
      config: 'responsive',
      excludeGroups: [],
    },
    mouse: {
      config: 'responsive',
      includeGroups: ['mouse', 'animation'],
    },
  },
  wix: {
    entrance: {
      config: 'wix',
      includeGroups: ['entrance', 'animation'],
      excludeGroups: ['legacy'],
    },
    entranceLegacy: {
      config: 'wix',
      includeGroups: ['entrance', 'animation', 'legacy'],
    },
    ongoing: {
      config: 'wix',
      includeGroups: ['ongoing', 'animation'],
    },
    scroll: {
      config: 'wix',
      includeGroups: ['scroll', 'animation'],
    },
    scrollIn: {
      config: 'wix',
      rangeGroup: 'in',
      includeGroups: ['scroll', 'in', 'animation'],
    },
    scrollOut: {
      config: 'wix',
      rangeGroup: 'out',
      includeGroups: ['scroll', 'out', 'animation'],
    },
    scrollContinuous: {
      config: 'wix',
      rangeGroup: 'continuous',
      includeGroups: ['scroll', 'continuous', 'animation'],
    },
    mouse: {
      config: 'wix',
      includeGroups: ['mouse', 'animation'],
    },
  },
} as const;
